<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
		<g
			:fill="active ? globalColors.titulo : globalColors.border"
			fill-rule="nonzero"
		>
			<path d="M19.481.519a1.602 1.602 0 0 0-1.175-.49H1.664C1.207.03.814.194.49.52A1.602 1.602 0 0 0 0 1.694v12.647c0 .458.163.85.489 1.176.326.326.718.489 1.175.489h16.642c.457 0 .85-.163 1.175-.49.326-.325.489-.717.489-1.175V1.694c0-.458-.163-.85-.489-1.175zm-.842 13.823a.32.32 0 0 1-.1.234.32.32 0 0 1-.233.098H1.664a.32.32 0 0 1-.234-.098.32.32 0 0 1-.099-.235V8.018H18.64v6.324zm0-10.318H1.33v-2.33a.32.32 0 0 1 .1-.234.32.32 0 0 1 .233-.099h16.642a.32.32 0 0 1 .234.099.32.32 0 0 1 .098.234v2.33z"/>
        	<path d="M2.663 12.012h2.663v1.331H2.663zM6.657 12.012h3.994v1.331H6.657z"/>
		</g>
	</svg>
</template>
<script>
export default {
	name: 'credit-card-svg',
	props: {
		active: {
			default: false,
			type: [Boolean, String],
		},
	},
};
</script>



// WEBPACK FOOTER //
// creditCardSvg.vue?3fc4a6bb